import { trimWhitespaceAndTrailing } from './trim-whitespace-and-trailing';

/**
 * Trim whitepspace and trailing path character from the end of `value` supplied
 * @param value The path to trim
 * @param pathCharacter The path separator character
 */
export const trimPath = (value: string | undefined, pathCharacter = '/') =>
  trimWhitespaceAndTrailing(value, pathCharacter);
